<a class="text-decoration-underline" href="javascript:void(0)" (click)="onResetPasswordClick()">{{
  changePasswordText
}}</a>

<ng-template #modalReset>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ 'password_reset.title' | translate }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="inputEmail">
      {{ 'password_reset.do_you_want_to_reset_your_password' | translate }}
    </p>
    <div *ngIf="!inputEmail">
      <div class="form-group">
        <label class="label" for="email">{{ 'password_reset.your_email' | translate }}:</label>
        <input class="form-control" type="email" id="email" [(ngModel)]="email" />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      nkButton
      color="success"
      [ghost]="!email"
      [disabled]="!email"
      (click)="modalRef.hide(); onSubmitPasswordReset()">
      {{ 'password_reset.reset_btn' | translate }}
    </button>
    <button nkButton color="secondary" (click)="modalRef.hide()">
      {{ 'password_reset.cancel_btn' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #modalSuccess>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ 'password_reset.password_reset_link_sent' | translate }} <i class="fa fa-check fa-green"></i>
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      <strong>{{ 'password_reset.check_your_mail_inbox' | translate }}</strong>
    </p>
  </div>
  <div class="modal-footer">
    <button nkButton color="secondary" (click)="modalRef.hide()">{{ 'password_reset.ok_btn' | translate }}</button>
  </div>
</ng-template>

<ng-template #modalError>
  <div class="modal-header">
    <h4 class="modal-title pull-left"><span class="warning">Error</span></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Something happened in our system. <br />
      <strong>Could not trigger password reset.</strong><br />
      Please contact us via mail and we will help you: <a href="mailto:team@enin.ai">team&#64;enin.ai</a>
    </p>
  </div>
  <div class="modal-footer">
    <button nkButton color="secondary" (click)="modalRef.hide()">{{ 'password_reset.ok_btn' | translate }}</button>
  </div>
</ng-template>
